<template>
  <div class="ly_modal_container" :style="{width: '970px', zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">받는사람</h1>
    </div>
    <div class="ly_modal_content" style="min-height: 485px">
      <ScrollTable ref="table" :sourceList="tableItems">
        <template #header>
          <caption>
            <span class="blind">받는사람</span>
          </caption>
          <colgroup>
            <col width="50" />
            <col width="120" />
            <col width="200" />
            <col width="250" />
            <col width="100" />
            <col width="100" />
            <col width="100" />
          </colgroup>

          <thead class="table_list_head">
            <tr>
              <CheckAllHeader :selectedList="selectedList" :sourceList="selectableList" />
              <th>이름</th>
              <th>TID</th>
              <th>그룹</th>
              <th>확인여부</th>
              <th>스피커알림</th>
              <th>상세</th>
            </tr>
          </thead>
        </template>
        <template #row="{rowData}">
          <tr :class="highlight(rowData)">
            <td>
              <input type="checkbox" :value="rowData" v-model="selectedList" :disabled="!rowData.resendButtonEnable" />
            </td>
            <td>{{ rowData.rcpName }}</td>
            <td>{{ rowData.rcpNuguTid }}</td>
            <td>{{ rowData.rcpGroup }}</td>
            <ConfirmTextColumn :value="rowData.rcpReadYn" />
            <PushStatusColumn displayType="RCP" :statusCode="rowData.pushStatus" />
            <td>
              <button v-if="detailLinkUrl(rowData)" type="button" class="btn_function" @click="$router.push(detailLinkUrl(rowData))">
                보기
              </button>
              <span v-else>-</span>
            </td>
          </tr>
        </template>
      </ScrollTable>

      <div class="btn_area">
        <button type="button" class="btn_active" @click="resend">알림 재전송</button>
        <button type="button" class="btn_default" @click="close">닫기</button>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import popupMixin from '$mixins/popup';
import newsMixin from '$views/News/_mixin';

export default {
  mixins: [popupMixin, newsMixin],
  props: {
    newsId: [String, Number],
    onResend: Function,
  },
  data() {
    return {
      selectedList: [],
      tableItems: null,
    };
  },
  computed: {
    selectableList() {
      return this.tableItems ? this.tableItems.filter((item) => item.resendButtonEnable) : null;
    },
  },
  methods: {
    // 같은링크면 링크 없도록
    detailLinkUrl(rowData) {
      const url = `/news/recipient/${rowData.rcpId}`;
      return url != this.$route.path ? url : null;
    },
    highlight(item) {
      if (!item.rcpReadYn) {
        if (item.pushStatus === 'FAIL') return 'highlight2';
        return 'highlight';
      }
    },
    onDetail(id) {
      this.$emit('targetDetailInfo', id);
    },
    async resend() {
      if (!this.selectedList.length) {
        alert(
          '알림을 보낼 대상자를 선택해 주세요.\n단, 이틀 지난 소식과 전송대기 상태의 대상자는 알림 대상이 아니므로 선택할 수 없습니다.',
        );
        return;
      }

      let rcpTarget = `${this.selectedList[0].rcpName}님`;
      if (this.selectedList.length > 1) rcpTarget += ` 외 ${this.selectedList.length - 1}명`;
      const message = `${rcpTarget}에게 다시 알림을 보내시겠습니까?\n(전체 소식 순서가 변경되지는 않습니다.)`;
      confirm(message).then(async () => {
        try {
          await this.$axios.put(`/admin/happy/news/${this.newsId}/resend`, {
            rcpIdList: _.map(this.selectedList, (item) => item.rcpId),
          });
          alert(`${rcpTarget}에게 알림 재전송 하였습니다.`);
          this.loadData();
          if (this.onResend) {
            this.onResend();
          }
        } catch (e) {
          // error
        }
      });
    },
    loadData() {
      this.$axios.get(`/admin/happy/news/${this.newsId}/rcp/lists`).then(({data}) => (this.tableItems = data.data));
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
